import styled from "styled-components";

import { theme } from "../../themes/themes";
export const SectionWrapper = styled.div`
  display: grid;
  padding: 1.4rem 2em;
  grid-template-columns: 1fr;
  grid-auto-rows: 1em auto;
  align-items: center;

  label {
    grid-column: 1/3;
    color: rgba(123, 123, 123, 1);
    font-size: 14px;
  }

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.button.primary};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const OptionWrapper = styled.div`
  margin-top: 6px;
  input {
    cursor: pointer;
    transform: scale(1.3);
  }
`;
export const ContentDependency = styled.div`
  width: 53%;
  height: 91vh;
  background: white;
  margin: 2em auto;
`;

export const UL = styled.ul`
  padding: 0 26px;
  height: 64vh;
  margin-right: 4px;
  overflow-y: auto;
  .dependency:nth-child(odd) {
    background: #dddddd52;
  }
  &::-webkit-scrollbar {
    width: 0.3em;
    margin-right: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #0008ff85;
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;
export const ContentQ = styled.div`
  padding: 9px 6px;
  height: auto;
  height: auto;
  display: grid;
  grid-template-columns: 1fr 2em;
  color: #2f2f2f;

  label {
    float: left;
    margin: 0;
  }
  button {
    float: right;
    padding: 0;
  }
`;
export const CloseModalDependency = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const StyledButton = styled.button`
  padding: 6px 12px;
  color: ${({ theme }) => theme.primaryColorLight};
  border-radius: 3px;
  border: none;
  margin: auto;
  display: block;
  background: ${({ theme }) => theme.button.primary};
  transition: transform 0.1s ease;
  min-width: 100px;
  &:hover {
    box-shadow: 0px 4px 20px 0px
      ${({ style, theme }) =>
        style ? style.backgroundColor : theme.secondaryPurple};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
